import $ from 'jquery';
import Backbone from 'backbone';
import { T_ } from '@shared/translation';

/*
* Captcha model
*/
export default Backbone.Model.extend({
  validate(attrs) {
    let msg;

    if (!attrs.recaptcha_challenge_field) {
      msg = T_('Internal error [missing challenge]');
      this.trigger('invalid', msg);
      return false;
    }
    if (!attrs.recaptcha_response_field) {
      msg = T_('Please type the words below');
      this.trigger('invalid', msg);
      return false;
    }
    if (!attrs.captcha_breakpoint_id) {
      msg = T_('Internal error [missing breakpoint id]');
      this.trigger('invalid', msg);
      return false;
    }
    if (!attrs.captcha_breakpoint_token) {
      msg = T_('Internal error [missing breakpoint token]');
      this.trigger('invalid', msg);
      return false;
    }
    return true;
  },

  checkCaptcha() {
    // Validate the model
    if (
      !this.validate({
        recaptcha_challenge_field: this.get('recaptcha_challenge_field'),
        recaptcha_response_field: this.get('recaptcha_response_field'),
        captcha_breakpoint_id: this.get('captcha_breakpoint_id'),
        captcha_breakpoint_token: this.get('captcha_breakpoint_token'),
      })
    ) {
      return false;
    }

    // Check with server
    $.ajax({
      url: '/users/i_am_human.php',
      context: this,
      type: 'POST',
      cache: false,
      data: {
        recaptcha_challenge_field: this.get('recaptcha_challenge_field'),
        recaptcha_response_field: this.get('recaptcha_response_field'),
        captcha_breakpoint_id: this.get('captcha_breakpoint_id'),
        captcha_breakpoint_token: this.get('captcha_breakpoint_token'),
        ajax: true,
      },
      dataType: 'JSON',
      success(resp) {
        if (resp.status == 'success') {
          this.trigger('success');
        } else if (resp.status == 'error' && resp.captcha == 'invalid') {
          this.trigger('invalid', "The words didn't match, please try again:");
        } else {
          this.trigger('invalid', 'Internal error [42]');
        }
      },
      error() {
        this.trigger('error', T_("Error: can't connect to server"));
      },
    });
  },
});
